import { api } from '@marketplace-web/core-api/core-api-client-util'

import { FeedbackResp, GetFeedbackArgs } from '../types/feedback'

export const getFeedback = ({ feedbackId, localize }: GetFeedbackArgs) =>
  api.get<FeedbackResp>(`/user_feedbacks/${feedbackId}`, {
    params: { localize },
  })
